export default "__VITE_ASSET__CYps2354__"